module.exports = __webpack_public_path__ + "img/youtube.43146d8f.svg";